module.exports = {"231071001":"牡丹江经济开发区城乡社区工作委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231071.json
// module id = 779
// module chunks = 0